import { complement, either, path } from 'ramda';
import { hasProduct, hasServiceOrAppointment } from '../order/selectors';

export const getActiveBarberId = path(['register', 'sale', 'activeBarberId']);

export const getSelectedCategory = path(['register', 'sale', 'productFilters', 'categoryId']);

export const getSelectedBrand = path(['register', 'sale', 'productFilters', 'brandId']);

export const getProductSearch = path(['register', 'sale', 'productFilters', 'productSearch']);

export const hasProductSearch = state => getProductSearch(state) !== '';

export const brandOrCategorySelected = either(
  getSelectedCategory,
  getSelectedBrand,
);

export const productFilterSelected = either(
  brandOrCategorySelected,
  hasProductSearch,
);

export const getServiceSearch = path(['register', 'sale', 'serviceSearch']);

export const shouldShowBrandsOrCategories = complement(productFilterSelected);

export const getCanShowProducts = (state, productSalesToShop) => {
  if (!productSalesToShop) return true;
  return !hasServiceOrAppointment(state, getActiveBarberId(state));
};

export const getCanShowServices = (state, productSalesToShop) => {
  if (!productSalesToShop) return true;
  return !hasProduct(state, getActiveBarberId(state));
};

export const getActiveTab = path(['register', 'sale', 'tab']);
